import { media } from "components/styles/breakpoints";
import styled, { css } from "styled-components";
import { UpgradeListTabs } from "types";

interface UpgradeTabsProps {
  selectedTab: UpgradeListTabs;
  onTabChange: (tab: UpgradeListTabs) => void;
}

const UpgradeTabsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
`;

const selectedTabMixin = css`
  color: #43fffa;
  border: 1px #43fffa solid;
`;

const UpgradeTab = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  border-radius: 4px;
  color: white;
  border: 1px transparent solid;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;

  ${media.desktop`
    font-size: 18px;
  `}

  ${({ isSelected }) => isSelected && selectedTabMixin};
`;

export const UpgradeTabs = ({ selectedTab, onTabChange }: UpgradeTabsProps) => {
  return (
    <UpgradeTabsWrapper>
      <UpgradeTab
        isSelected={selectedTab === "available"}
        onClick={() => onTabChange("available")}
      >
        Available
      </UpgradeTab>
      <UpgradeTab
        isSelected={selectedTab === "storage"}
        onClick={() => onTabChange("storage")}
      >
        Storage
      </UpgradeTab>
    </UpgradeTabsWrapper>
  );
};
